import React from "react"
import { useState,useEffect } from "react"
import General from "services/GeneralEndpoints"


  
const user = JSON.parse(localStorage.getItem("authUser"))

let generalService = new General(user)




const RequiredDocs = props => {
  const [RequiredDocuments, setRequiredDocuments] = useState([])
  useEffect(() => {
    fetchServiceAttachments(props.service_id)
  }, [])

  const fetchServiceAttachments = service_id => {
    generalService.getServiceAttachments(service_id).then(response => {
      console.log(response)
      if (response.status) {
        const attachments = response.data.map((item, index) => {
          return (
            <li>
              <span
                key={index}
                value={item.id}
                className="text-dark badge badge-primary"
              >
                {item.description}
              </span>
            </li>
          )
        })
        setRequiredDocuments(attachments)
      }
    })
  }

  return (
    <div>
      <div>
        <span className="text-dark d-block my-4 font-weight-bold">
          First time application:
        </span>
        <ul className="doc-list doc-list d-block">
          <li>{RequiredDocuments}</li>
        </ul>
      </div>
    </div>
  )
}

export default RequiredDocs
